import { GlobeAltIcon, MapIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import { forIn } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import Select from "react-select";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const GenerateAwb = () => {
  const [startAwbNo, setStartAwbNo] = useState<number>();
  const [qty, setQty] = useState<number>(1);

  const [productList, setProductList] = useState<any>([]);
  const [selectedProduct, setSelectedProduct] = useState<any>();

  const [branchList, setBranchList] = useState<any>([]);
  const [selectedBranch, setSelectedBranch] = useState<any>();

  const [selectedCustomer, setBranchOtp] = useState<any>();
  const [customerList, setcustomerList] = useState<any>([{ value: 0, label: "Loading..." }]);
  const [result, setResult] = useState([]);

  useQuery(["ProductListApi"], () => ListCommanWay("/admin/product/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        console.log(data.data.data);
        setProductList(data.data.data);
      }
    },
  });

  useQuery(["subbranchListApi"], () => ListCommanWay("/admin/subbranch/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        setBranchList(data.data.data);
      }
    },
  });

  useQuery(["CustomersListApi"], () => ListCommanWay("/admin/customer/list", {isActive: true}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.code,
            label: p.code + " - " + p.sh,
          });
        });
        setcustomerList(opt);
      }
    },
  });

  const { refetch: refetchLastAwb } = useQuery(
    ["refetchLastAwbApi"],
    () =>
      ListCommanWay(
        "/admin/awb_data/get_last",
        {
          product: selectedProduct?.product_code,
        },
        { paginate: 1000 }
      ),
    {
      enabled: false,
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          try {
            if (data.data.data[0].postfix) {
              setStartAwbNo(Number(data.data.data[0].postfix) + 1);
            }
          } catch (c) {
            setStartAwbNo(10000000000 + 1);
          }
        }
      },
    }
  );
  useEffect(() => {
    if (selectedProduct && selectedProduct?.product_code) {
      refetchLastAwb();
    }
  }, [selectedProduct]);

  useEffect(() => {
    console.log("branmch list change", branchList);
  }, [branchList]);

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(
    (awb_no) =>
      CreateCommanWay({
        url: "/admin/awb/create",
        data: {
          startAwbNo: startAwbNo,
          quantity: qty,
          product: selectedProduct.product_code,
          subbranch: selectedBranch.id,
        },
      }),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          Swal.fire({
            title: "Assign Success",
            icon: "success",
          });
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const handleSubmit = () => {
    console.log(startAwbNo);
    mutate(startAwbNo);
  };
  const handlePrint = () => {
    let w = window.open();
    w.document.write(`<body style="margin: 0">${document.getElementById("result").innerHTML}</body>`);
    w.print();
    w.close();
  };


  return (
    <>
      <h1 className="text-center mb-4 mt-3 text-lg font-semibold underline">AWB Generate and assign</h1>

      <div className="flex flex-col gap-4 px-4">
        <div className="flex gap-4 flex-wrap border p-2 rounded-2xl items-center">
          <div className={`items-center gap-2 w-auto`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Product</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full`}
              options={productList}
              getOptionValue={(e: any) => {
                return e.id;
              }}
              getOptionLabel={(e: any) => {
                return e.product_name;
              }}
              onChange={(e: any) => {
                setSelectedProduct(e);
              }}
              name={"product"}
            />
          </div>

          <div className={` items-center gap-2 w-auto`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Start</label>
            <input
              type="number"
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={"Starting From"}
              name="startAwbNo"
              value={startAwbNo || ""}
              onBlur={(e) => {
                setStartAwbNo(Number(e.target.value));
              }}
              onChange={(e) => setStartAwbNo(Number(e.target.value))}
            />
          </div>

          <div className={` items-center gap-2 w-auto`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Quantity</label>
            <input
              type="number"
              className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={"Starting From"}
              name="qty"
              value={qty}
              onBlur={(e) => {
                setQty(Number(e.target.value));
              }}
              onChange={(e) => setQty(Number(e.target.value))}
            />
          </div>

          <div className={` items-center gap-2 w-auto`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Branch</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full`}
              options={branchList}
              getOptionValue={(e: any) => {
                return e.id;
              }}
              getOptionLabel={(e: any) => {
                return e.branch_name;
              }}
              onChange={(e: any) => {
                setSelectedBranch(e);
              }}
              name={"branch"}
            />
          </div>

          <div className={`items-center gap-2`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Customer</label>
            <Select
              className={`${false ? "bg-gray-300" : ""} w-72 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
              options={customerList}
              onChange={(e) => {
                setBranchOtp(e);
              }}
              value={selectedCustomer}
              isClearable={true}
            />
          </div>

          <button
            type="button"
            onClick={handlePrint}
            className="rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Print
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
          >
            Assign
          </button>
        </div>
        <div id="result">
          {[...Array(qty)].map((e, i) => {
            let main_string = startAwbNo + i;
            let divide_calc = main_string / 7;
            let mutiply_string = Number(divide_calc.toFixed(1));

            let n = mutiply_string.toString().indexOf(".");
            if (n != -1) {
              let aa = mutiply_string.toString().split(".")[1];
              mutiply_string = Math.round(parseFloat("0." + aa) * 7);
            } else {
              mutiply_string = 0;
            }

            let code = selectedProduct?.product_code + (startAwbNo + i).toString() + mutiply_string;

            return (
              <>
                <div style={{ height: "4.8cm", width: "4.8cm", display: "inline-block" }}>
                  <div style={{ textAlign: "center", fontFamily: "arial" }}>
                    <p style={{ margin: "0.1cm 0", lineHeight: 1, fontWeight: 600 }}>AIRFIELD EXPRESS</p>
                    {/*<Barcode value={code} marginTop={0.75} width={1.5} height={50} />*/}
                    <QRCode value={code} size={77} style={{ display: "inline-block" }} />
                    <p style={{ margin: "0.1cm 0", lineHeight: 1, fontWeight: 600, fontSize: "0.4cm" }}>{code}</p>
                    <div style={{ marginTop: "0.1cm" }}>
                      <p style={{ fontSize: "0.8em", margin: 0, lineHeight: 1 }}>Track us: www.airfield.co.in</p>
                      <p style={{ fontSize: "0.8em", margin: 0, lineHeight: 1 }}>Email Id: info@airfield.co.in</p>
                      <p style={{ fontSize: "0.8em", margin: 0, lineHeight: 1 }}>Tollfree No.: 92272 23131</p>
                      <b style={{ fontSize: "0.45cm" }}>
                        {selectedCustomer ? selectedCustomer?.value : selectedBranch && selectedBranch?.branch_code}
                      </b>
                    </div>
                  </div>
                </div>
                {(i + 1) % 2 == 0 && <div style={{ pageBreakAfter: "always" }}></div>}
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default GenerateAwb;
